import FacebookLogin from "react-facebook-login";
import { Trans, useTranslation } from "react-i18next";
import dompurify from "dompurify";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import Button from "../../components/shared/button/component";
const RBResetPassword = ({
  onpasswordChange,
  password,
  onconfirmPasswordChange,
  confirmPassword,
  pwdErrorMsg,
  saveClickHandler,
  navigateSignIn,
  navigateSignUp,
}) => {
  const { t } = useTranslation();
  const sanitizer = dompurify.sanitize;
  return (
    <>
      <Helmet>
        <meta name="description" content={t("reset_password.rb.description_meta")}/>
        <title>{t("page_title.reset_password")}</title>
      </Helmet>
      <section className="main-content ">
        <div className="container mx-auto">
          <div className="form-wrap">
            <div className="form-container">
              <hgroup className="text-center mb-4">
                <h1 className="main-headline uppercase font-bold text-2xl md:text-xl lg:text-xl">
                  {t("reset_password.headline")}
                </h1>
              </hgroup>
              <div className="form-group">
                <InputText
                  showLabel={false}
                  className="border border-gray-300 rounded-sm px-3 py-2 md:py-1 lg:py-1 border mb-2"
                  required="required"
                  id="password"
                  text="Password"
                  type="password"
                  name="password"
                  maxlength="128"
                  onChange={onpasswordChange}
                  value={password}
                  placeholder={t("reset_password.placeholder_new_password")}
                />
              </div>
              <div className="form-group">
                <InputText
                  showLabel={false}
                  className="border border-gray-300 rounded-sm px-3 py-2 md:py-1 lg:py-1 border mb-2"
                  required="required"
                  id="confirmPassword"
                  text="Password"
                  type="password"
                  name="confirmPassword"
                  maxlength="128"
                  onChange={onconfirmPasswordChange}
                  value={confirmPassword}
                  placeholder={t("reset_password.placeholder_confirm_password")}
                />
              </div>
              <div className="form-text">
                <small className="form-text text-red-500">{pwdErrorMsg}</small>
              </div>
              <div className="fbn fixed md:relative bottom-0 left-0 bg-white  border-gray-300 p-2.5 md:p-0 lg:p-0 text-center w-full z-50">
                <Button
                  isLoading={false}
                  disabled={false}
                  className=" bg-[#fe8c26] hover:bg-[#f07201] transition-all duration-400 ease-out delay-100 active:bg-blue-500 text-white uppercase rounded font-semibold py-3 w-full "
                  onClick={saveClickHandler}
                  ctaText={t("reset_password.btn_cta")}
                />
              </div>
              <div className="form-container--footer !p-3 text-center">
                <p className="text-xs leading-3">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: sanitizer(t("sign_up.already_account")),
                    }}
                  />
                  <Button
                    onClick={navigateSignIn}
                    className="btn btn-link px-0  text-[#2ebe6e] hover:text-blue-500"
                    ctaText={t("sign_up.sign_in")}
                  />
                </p>
                <p className="text-xs leading-3">
                  {t("sign_in.create_account")}
                  <Button
                    onClick={navigateSignUp}
                    className="btn btn-link px-0  text-[#2ebe6e] hover:text-blue-500"
                    ctaText={t("sign_in.create_signup")}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RBResetPassword;
